import { Route, RouteComponentProps, Switch, useHistory } from 'react-router-dom';

import { useAuthenticatedUser } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import CycleMomentSelectorModal from '../../../../kakapo-ui-kit/components/cycles/CycleMomentSelectorModal';
import FeedbackRequestModal, {
	FeedbackRequestModalMoment,
	FeedbackRequestModalSuggestion,
} from '../request-modal/FeedbackRequestModal';
import SendFeedbackModal from './SendFeedbackModal';

export default function FeedbackRequestModals(props: { userID: string; refetch: () => void }) {
	const history = useHistory();
	const viewer = useAuthenticatedUser();

	const isViewer = viewer.id === props.userID;

	const returnURL = (() => {
		const params = new URLSearchParams(history.location.search);
		if (params.has('return') && params.get('return')?.startsWith('/')) {
			return params.get('return');
		}
		return isViewer ? '/feedback' : `/users/${props.userID}/feedback`;
	})() as string;

	return (
		<Switch>
			<Route path={['/feedback/send', `/users/:userID/feedback/send`]} exact>
				{({ match }: RouteComponentProps<{ userID?: string }>) => (
					<SendFeedbackModal userID={match!.params.userID} />
				)}
			</Route>
			<Route
				path={[
					'/feedback/request-from-moment',
					`/users/${props.userID}/feedback/request-from-moment`,
				]}
				exact
			>
				<CycleMomentSelectorModal
					type={graphql.MomentType.Feedback}
					returnURL={returnURL}
					regularURL={isViewer ? '/feedback/request' : `/users/${props.userID}/feedback/request`}
					momentURL={(moment) => `/users/${props.userID}/feedback/request-from-moment/${moment.id}`}
				/>
			</Route>
			<Route path={['/feedback/request', `/users/${props.userID}/feedback/request`]} exact>
				<FeedbackRequestModal
					userID={props.userID}
					returnURL={returnURL}
					refresh={() => props.refetch()}
				/>
			</Route>
			<Route
				path={[
					'/feedback/request/competencies',
					`/users/${props.userID}/feedback/request/competencies`,
				]}
				exact
			>
				<FeedbackRequestModal
					method="competencies"
					userID={props.userID}
					returnURL={returnURL}
					refresh={() => props.refetch()}
				/>
			</Route>
			<Route
				path={[
					`/feedback/request-from-moment/:momentID`,
					`/users/${props.userID}/feedback/request-from-moment/:momentID`,
				]}
				exact
			>
				<FeedbackRequestModalMoment
					userID={props.userID}
					returnURL={returnURL}
					refresh={() => props.refetch()}
				/>
			</Route>
			<Route
				path={[
					'/feedback/request-from-suggestion',
					`/users/${props.userID}/feedback/request-from-suggestion`,
				]}
				exact
			>
				<FeedbackRequestModalSuggestion
					userID={props.userID}
					returnURL={returnURL}
					refresh={() => props.refetch()}
				/>
			</Route>
		</Switch>
	);
}
